import { ReqBodyType } from '../types/reqBody';
import HttpClient from '../utils/HttpClient';

interface DashboardServiceInterface {
    codUsu?: number;
    perfilUsu?: number;
    token: string;
    reqBody?: ReqBodyType;
    codEmpresa?: number;
    usuario?: string;
}

class DashboardService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  getDashboardData = async({
    codUsu,
    perfilUsu,
    token,
    reqBody,
  }: DashboardServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_DashBFreta?codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
      reqBody,
    });
  };

  getWorkplaces = async({
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
  }: DashboardServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_FretaCadVeiculoAlt?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  getRelsData = async({
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
    reqBody,
  }: DashboardServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_FretaRels?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  getMapaShape = async({
    codUsu,
    perfilUsu,
    usuario,
    codEmpresa,
    token,
    reqBody,
  }: DashboardServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_ViagemMapa?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  getStartDate = async({
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
  }: DashboardServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_IniciaServico?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };

  chooseStartDate = async({
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
    reqBody,
  }: DashboardServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_IniciaServico?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };
}

export default new DashboardService();
